import config from 'configs';
import { isIOS, isAndroid, isChromeAgent, isFirefoxAgent } from 'utils';

const { metamaskExtensionUrl } = config;

const getMetamaskExtensionUrl = () => {
  let deviceType;
  if (isIOS) {
    deviceType = 'iOS';
  } else if (isAndroid) {
    deviceType = 'android';
  } else if (isChromeAgent) {
    deviceType = 'chrome';
  } else if (isFirefoxAgent) {
    deviceType = 'firefox';
  }
  return metamaskExtensionUrl[deviceType];
};

export default getMetamaskExtensionUrl;
